import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    Box,
    Button,
    Divider
} from "@mui/material";
import { CheckCircle, Download } from "lucide-react";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";

const PaymentResultModal = () => {
    const [open, setOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const status = searchParams.get("status");
    const txRef = searchParams.get("tx_ref");
    const transactionId = searchParams.get("transaction_id");

    useEffect(() => {
        if (status && txRef && transactionId) {
            setOpen(true);
        }
    }, [status, txRef, transactionId]);

    const handleDownloadPDF = () => {
        const receipt = document.getElementById("payment-receipt");

        if (!receipt) return;

        const printWindow = window.open("", "_blank", "width=800,height=600");

        printWindow.document.write(`
    <html>
      <head>
        <title>Payment Receipt</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 40px;
            color: #111;
          }

          h1 {
            text-align: center;
            margin-bottom: 24px;
          }

          .row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            font-size: 14px;
          }

          .label {
            color: #555;
          }

          .value {
            font-weight: 600;
          }

          .divider {
            margin: 24px 0;
            border-top: 1px solid #ddd;
          }

          .success {
            text-align: center;
            color: #16a34a;
            font-size: 18px;
            font-weight: bold;
          }
        </style>
      </head>
      <body>
        ${receipt.innerHTML}
      </body>
    </html>
  `);

        printWindow.document.close();

        printWindow.focus();
        printWindow.print();

        printWindow.onafterprint = () => {
            printWindow.close();
        };
    };


    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    overflow: "hidden"
                }
            }}
        >
            <DialogContent
                id="payment-receipt"
                sx={{
                    p: 4,
                    textAlign: "center"
                }}
            >
                {/* Success Icon */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 2
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "48px",
                            color: "#16a34a",
                            fontWeight: "bold"
                        }}
                    >
                        ✓
                    </Typography>

                </Box>

                <Typography variant="h5" fontWeight={700} gutterBottom>
                    Payment Successful
                </Typography>

                <Typography color="text.secondary" mb={3}>
                    Your transaction has been completed successfully.
                </Typography>

                <Divider sx={{ my: 3 }} />

                {/* Receipt Details */}
                <Box sx={{ textAlign: "left" }}>
                    <ReceiptRow label="Status" value={status} />
                    <ReceiptRow label="Transaction Reference" value={txRef} />
                    <ReceiptRow label="Transaction ID" value={transactionId} />
                    <ReceiptRow
                        label="Date"
                        value={dayjs().format("DD MMM YYYY, hh:mm A")}
                    />
                </Box>

                <Divider sx={{ my: 3 }} />

                {/* Actions */}
                {/* <Button
                    fullWidth
                    variant="contained"
                    startIcon={<Download />}
                    sx={{
                        py: 1.5,
                        fontWeight: 600,
                        borderRadius: "10px"
                    }}
                    onClick={handleDownloadPDF}
                >
                    Download PDF
                </Button> */}

                <Button
                    fullWidth
                    variant="text"
                    sx={{ mt: 1 }}
                    onClick={() => {
                        setOpen(false);
                        // remove all query params from the URL
                        setSearchParams({}, { replace: true });
                    }}
                >
                    Close
                </Button>
            </DialogContent>

            {/* Print styles */}
            <style>
                {`
          @media print {
            body * {
              visibility: hidden;
            }
            #payment-receipt, #payment-receipt * {
              visibility: visible;
            }
            #payment-receipt {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }
        `}
            </style>
        </Dialog>
    );
};

const ReceiptRow = ({ label, value }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 1.5
        }}
    >
        <Typography color="text.secondary">{label}</Typography>
        <Typography fontWeight={600}>{value}</Typography>
    </Box>
);

export default PaymentResultModal;
